module.exports = __webpack_public_path__ + "img/37_176.dbf0c610.png";